import ls from 'localstorage-slim';
import { useRoutes } from 'react-router-dom';
import { customTTL } from '../constants';
import { useAppDispatch, useAppSelector } from '../redux/store/storehooks';

const setToStorage = (name:any,data:any) => {

    let complex:any = {data:data,timestamp: new Date().getTime()}
    localStorage.setItem(name,complex);
   
    if (name === "jwt") 
    {
        ls.set(name, data, { ttl: customTTL });
    }
    else
    {
        ls.set(name, data);
    }

}

const pureSetToStorage = (name:any,data:any) => {
    localStorage.setItem(name,data);
}

const getFromStorage = (name:any):any => {
    let res = ls.get(name);
    return res
}

const pureGetFromStorage = (name:any):any => {
    let res = localStorage.getItem(name);
    return res
}

const removeFromStorage = (name:any) => {
    ls.remove(name);
}

const removeAllFromStorage = () => {
    ls.clear();
}


export {setToStorage,getFromStorage,removeFromStorage,removeAllFromStorage}